export const ROUTES = {
  ROOT: { path: '/', title: 'Home' },
  CALCULATOR: { path: '/calculator', title: 'Calculator' },
  CARD_VIEWER: { path: '/card_viewer', title: 'Card Search' },
}

 